import { FC } from 'react'
import styles from 'components/features/external/PublicSpendingTrend/LineChartAxis.styl'
import { AXIS_WIDTH } from 'components/features/external/PublicSpendingTrend/constants'
import { Point } from 'components/features/external/PublicSpendingTrend/helpers'

type LineChartAxisProps = {
  points: Point[]
  zero: number
  width: number
}

export const LineChartAxis: FC<LineChartAxisProps> = (props) => {
  const { zero, width, points } = props

  const sectionWidth = (width - AXIS_WIDTH) / (points.length - 1)

  return (
    <>
      <rect y={ zero } x='0' width='100%' height='2' className={ styles.lineChartAxis } />
      {
        points.map((_point, index) => (
          <rect
            key={ index }
            y={ zero }
            x={ index * sectionWidth }
            width={ AXIS_WIDTH }
            height='6'
            className={ styles.lineChartAxis }
          />

        ))
      }
    </>
  )
}
